import apiClient from "../apiClient";

export const UsersAPI = {
  getMyselfDetails: () => apiClient.get("/api/v1/employees/me/details"),
  getAllPaginated: (params) => {
    const searchParams = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        searchParams.append(key, String(value));
      }
    });
    return apiClient.get(`/api/v1/employees?${searchParams.toString()}`);
  },
  getAllEmploymentStatuses: () =>
    apiClient.get("/api/v1/employees/employment/statuses"),
  createUser: (userData) => apiClient.post("/api/v1/employees", userData),
  getEmployeeById: (id) => {
    return apiClient.get(`/api/v1/employees/${id}`);
  },
  updateUser: (id, userData) =>
    apiClient.patch(`/api/v1/employees/${id}`, userData),
  getAllJobPositions: () => apiClient.get("/api/v1/employees/job/positions"),
  getAllJobGrades: () => apiClient.get("/api/v1/employees/job/grades"),
  deleteEmployee: (id) => apiClient.delete(`/api/v1/employees/${id}`),
};
